import { createContext } from 'react';
import { LoadingContextModel } from './loading.model';

export const LoadingContext = createContext<LoadingContextModel>(null as any);
